import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import './error.css';
import NotFoundPage from "./NotFound";
import { Col, Row } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";

export default function ErrorHandler() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return NotFoundPage();
  }

  return (
    <div id="error-page" className="m-auto">
      <h1>Oops!</h1>
      <hr />
      <Row>
        <Col id="content" xs={12} lg={9}>
          {isRouteErrorResponse(error) ? <>
            <h2>Errore {error.status}</h2>
            <p>{error.statusText}</p>
            {error.data?.message && <p>{error.data.message}</p>}
          </> : <>
            {/* <h2>An unexpected error occurred while loading the requested page</h2>
            <br />
            <h3>Please try again later or contact the website administrator:</h3> */}
            <h2>Si è verificato un errore imprevisto durante il caricamento della pagina</h2>
            <br />
            <h3>Per favore riprova più tardì oppure contatta l'amministratore del sito web:</h3>
            <br />
            <h4><a href="mailto:redazione@calcio5live.com" title="Invia un'email all'amministratore">
              redazione@calcio5live.com
            </a></h4>
          </>}
        </Col>
        <Col id="sidebar" xs={12} lg={3} className="pt-3">
          <Sidebar />
        </Col>
      </Row>
    </div>
  );
}